import React, { useEffect, useState } from 'react';
import { UserOutlined, TeamOutlined } from '@ant-design/icons';
import { useContact } from '../../contexts/ContactContext';
import { RoleType, Contact, ContactService } from '../../services/contact.api.client';
import { UnifiedContactView } from "@ryo/ui";
import { useConfig } from '../../contexts/ConfigContext';
import { useCompany } from '../../contexts/CompanyContext';

export default function ContactPage() {
    const { contacts, loadings, fetchContacts, createContact, updateContact } = useContact();
    const [activeRole, setActiveRole] = useState<RoleType>('EMPLOYEE');

    useEffect(() => {
        fetchContacts(activeRole);
    }, [activeRole, fetchContacts]);

    const { config } = useConfig();
    const { company } = useCompany();

    const handleEditRequest = async (record: any) => {
        if (!company?.current?.uid || !config?.key) return record;

        const res = await ContactService.getContactById(
            record.uid,
            company.current.uid,
            config.key
        );

        if (res?.message || res?.err) {
            throw new Error(res.message || res.err || "Error al obtener el contacto");
        }

        const contactData = res?.contact || res;

        if (contactData && !contactData.uid && record.uid) {
            contactData.uid = record.uid;
        }
        if (contactData && !contactData.id && record.id) {
            contactData.id = record.id;
        }

        return contactData;
    };

    const handleSave = async (values: any) => {
        const contactData = {
            ...values
        };
        if (values.uid) {
            const res = await updateContact(values.uid, contactData);
            if (res?.message || res?.err) {
                throw new Error(res?.message || res?.err || 'Error al actualizar el contacto');
            }
        } else {
            contactData.roles = [{ role_type: activeRole }]
            const res = await createContact(contactData);
            if (res?.message || res?.err) {
                throw new Error(res?.message || res?.err || 'Error al crear el contacto');
            }
        }
    };

    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'name',
            key: 'name',
            render: (text: string) => <span style={{ fontWeight: 500 }}>{text}</span>,
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Teléfono',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'Documento',
            key: 'document',
            render: (_: any, record: Contact) => (
                <span>{record.document_type}: {record.document_number}</span>
            ),
        },
    ];

    return (
        <UnifiedContactView
            title="Gestión de Contactos"
            roles={[
                { key: 'EMPLOYEE', label: 'Empleados', icon: <UserOutlined style={{ marginRight: 8 }} /> },
                { key: 'CUSTOMER', label: 'Clientes', icon: <TeamOutlined style={{ marginRight: 8 }} /> }
            ]}
            activeRole={activeRole}
            onRoleChange={(key) => setActiveRole(key as RoleType)}
            dataSource={contacts.filter(c => c.role === activeRole)}
            loading={loadings[activeRole]}
            onSearch={() => { /* Calendar currently doesn't have a search logic in ContactPage, but could be added here */ }}
            onSave={handleSave}
            onEditRequest={handleEditRequest}
            onSuccess={() => fetchContacts(activeRole)}
            validationMode="relaxed"
            columns={columns}
        />
    );
}
